import { Grid, GridItem } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ObstacleInput } from "../types/sharedTypes";
import { ObstacleFormValueInput } from "./obstacleFormValueInput";

type ObstacleFormInputProps = {
  obstacle: ObstacleInput;
  onValueChange: (valueType: keyof ObstacleInput, newValue: number) => void;
};

export const ObstacleFormInput: FunctionComponent<ObstacleFormInputProps> = ({
  obstacle,
  onValueChange,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "components.obstacleFormInput",
  });
  return (
    <>
      <Grid rowGap={2}>
        <GridItem>
          <ObstacleFormValueInput
            label={t("distance")}
            value={obstacle.distance}
            onValueChange={(newValue) => onValueChange("distance", newValue)}
          />
        </GridItem>
        <GridItem>
          <ObstacleFormValueInput
            label={t("depth")}
            value={obstacle.depth}
            onValueChange={(newValue) => onValueChange("depth", newValue)}
          />
        </GridItem>
        <GridItem>
          <ObstacleFormValueInput
            label={t("height")}
            value={obstacle.height}
            onValueChange={(newValue) => onValueChange("height", newValue)}
          />
        </GridItem>
      </Grid>
    </>
  );
};
